/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plum_Bronze_Fish_NapInputs */

const en_plum_bronze_fish_nap = /** @type {(inputs: Plum_Bronze_Fish_NapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by labels`)
};

const de_plum_bronze_fish_nap = /** @type {(inputs: Plum_Bronze_Fish_NapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Labels filtern`)
};

/**
* | output |
* | --- |
* | "Filter by labels" |
*
* @param {Plum_Bronze_Fish_NapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plum_bronze_fish_nap = /** @type {((inputs?: Plum_Bronze_Fish_NapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plum_Bronze_Fish_NapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plum_bronze_fish_nap(inputs)
	return de_plum_bronze_fish_nap(inputs)
});